export const SET_LOGIN_DATA = 'SET_LOGIN_DATA';
export const SET_JWT = 'SET_JWT';
export const ADD_BANK_ACCOUNT = 'ADD_BANK_ACCOUNT';
export const SET_MERCHANTS = 'SET_MERCHANTS';
export const DISABLE_BANK_ACCOUNTS = 'DISABLE_BANK_ACCOUNTS';
export const DELETE_LOGIN_VALUES = 'DELETE_LOGIN_VALUES';
export const SET_USER_AUTH = 'SET_USER_AUTH';
export const DELETE_USER_AUTH = 'DELETE_USER_AUTH';
export const SET_RECOVER_EMAIL = 'SET_RECOVER_EMAIL';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_LINK = 'SET_LINK';
export const SET_DOCUMENT_STATUS = 'SET_DOCUMENT_STATUS';
export const SET_LOGUED_AS = 'SET_LOGUED_AS';
export const SET_AUTH = 'SET_AUTH';
export const LOGOUT = 'LOGOUT';
export const SET_ACCESS_CONTROL = 'SET_ACCESS_CONTROL';
export const UPDATE_AUTO_CASHOUT = 'UPDATE_AUTO_CASHOUT';
export const SET_TERMS_EXPIRATION_DATE = 'SET_TERMS_EXPIRATION_DATE';
export const SET_TERMS_VERSION = 'SET_TERMS_VERSION';
export const SET_IS_TERMS_EXPIRED = 'SET_IS_TERMS_EXPIRED';
export const SET_TERMS_CONDITIONS = 'SET_TERMS_CONDITIONS';
export const SET_USERS_BY_RUT = 'SET_USERS_BY_RUT';
export const SET_ERROR_USERS_BY_RUT = 'SET_ERROR_USERS_BY_RUT';
export const CLEAN_USERS_BY_RUT = 'CLEAN_USERS_BY_RUT';
export const SUCCESS_DISABLE_VIEW_POP_UP = 'SUCCESS_DISABLE_VIEW_POP_UP';
